/**
 * Shared navigation row used by both `/worldcup/strategy` and
 * `/worldcup/matchday/:md` so users can flip between Round Call and the
 * other strategy tools without losing context.
 *
 * - `activeKey` highlights one tab.
 * - For Strategy-internal tabs (match-calls, captain-chain, ...) the caller
 *   passes `onTabClick` to switch state without a navigation.
 * - The "round-call" entry always navigates to /worldcup/matchday/1.
 */
import React from "react";
import { Link } from "react-router-dom";
import {
    Crown, Couch, Users, GridFour, Sparkle, Robot,
} from "@phosphor-icons/react";
import { DEFAULT_ADMIN_MD_PATH } from "../lib/wcRounds";
export const WC_NAV_TABS = [
    { key: "round-call", label: "Round Call", icon: Sparkle, to: DEFAULT_ADMIN_MD_PATH },
    { key: "captain-chain", label: "Captain Chain", icon: Crown, strategy: true },
    { key: "ai-analyzer", label: "AI Analyzer", icon: Robot, strategy: true },
    { key: "bench-safety", label: "Bench Safety", icon: Couch, strategy: true },
    { key: "crowd-captaincy", label: "Crowd Captaincy", icon: Users, strategy: true },
    { key: "captain-heatmap", label: "Captain Heatmap", icon: GridFour, strategy: true },
];

export default function WCStrategyNav({ activeKey, onTabClick }) {
    return (
        <div className="flex items-center gap-2 border-b border-white/10 flex-wrap" data-testid="wc-nav-tabs">
            {WC_NAV_TABS.map((t) => {
                const Icon = t.icon;
                const active = activeKey === t.key;
                const className = `font-mono text-[11px] uppercase tracking-widest px-4 py-2.5 border-b-2 flex items-center gap-1.5 transition-colors ${
                    active
                        ? "border-fa-yellow text-fa-yellow"
                        : "border-transparent text-white/40 hover:text-white"
                }`;
                // Round Call always navigates; strategy tabs use callback if provided
                if (t.strategy && onTabClick) {
                    return (
                        <button
                            key={t.key}
                            type="button"
                            onClick={() => onTabClick(t.key)}
                            data-testid={`wc-nav-${t.key}`}
                            className={className}
                        >
                            <Icon size={11} weight={active ? "fill" : "regular"} />
                            {t.label}
                        </button>
                    );
                }
                // No state handler (we're on matchday page) → link to strategy
                const to = t.strategy ? `/worldcup/strategy?tab=${t.key}` : t.to;
                return (
                    <Link
                        key={t.key}
                        to={to}
                        data-testid={`wc-nav-${t.key}`}
                        className={className}
                    >
                        <Icon size={11} weight={active ? "fill" : "regular"} />
                        {t.label}
                    </Link>
                );
            })}
        </div>
    );
}
